import {
  Brain, Building2, FileSearch, Target, PenTool, PartyPopper, Star, Users, Calendar, BarChart3, TrendingUp,
} from "lucide-react";

export const navGroups = (s) => [
  { id: "point", title: s("g1"), sub: s("g1_sub"), items: [
    { to: "/app/diagnostic", id: "diagnostic", label: s("n_diag"), icon: Brain },
    { to: "/app/profile-360", id: "profile-360", label: s("n_company"), icon: Building2 },
    { to: "/app/plan", id: "plan", label: s("n_plan"), icon: Target },
    { to: "/app/documents", id: "documents", label: s("n_docs"), icon: FileSearch, advanced: true },
  ] },
  { id: "clients", title: s("g2"), sub: s("g2_sub"), items: [
    { to: "/app/content", id: "content", label: s("n_post"), icon: PenTool },
    { to: "/app/event", id: "event", label: s("n_event"), icon: PartyPopper },
    { to: "/app/reputation", id: "reputation", label: s("n_reviews"), icon: Star },
    { to: "/app/loyalty", id: "loyalty", label: s("n_loyalty"), icon: Users },
    { to: "/app/calendar", id: "calendar", label: s("n_calendar"), icon: Calendar },
  ] },
  { id: "results", title: s("g3"), sub: s("g3_sub"), items: [
    { to: "/app/results", id: "results", label: s("n_results"), icon: BarChart3 },
    { to: "/app/growth", id: "growth", label: s("n_sim"), icon: TrendingUp, advanced: true },
  ] },
];
